import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=983fb44e&"
import script from "./CreateCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateCampaign.vue?vue&type=script&lang=js&"
import style0 from "./CreateCampaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports